var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgNoteCorrection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.76581 0H5.22205C5.03564 0 4.85675 0.0741577 4.72491 0.205994L0.206238 4.72467C0.0744018 4.85651 0.000244141 5.0354 0.000244141 5.2218V13.7906C0.000244141 15.0089 0.991394 16 2.20959 16H9.76581C10.9805 16 11.9752 15.0178 11.9752 13.7906V2.20935C11.9752 0.994629 10.9932 0 9.76581 0ZM5.27203 1.6474V4.46869C5.27203 4.91162 4.91187 5.27179 4.46893 5.27179H1.64764L5.27203 1.6474ZM10.5689 13.7906C10.5689 14.2281 10.2153 14.5938 9.76581 14.5938H2.20959C1.76685 14.5938 1.40649 14.2334 1.40649 13.7906V6.67822H4.46893C5.68713 6.67822 6.67828 5.68707 6.67828 4.46887V1.40625H9.76581C10.2034 1.40625 10.5689 1.76001 10.5689 2.20935V13.7906Z",
    fill: "#0E4C54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgNoteCorrection);
export default __webpack_public_path__ + "static/media/imgNoteCorrection.f4b009a9e7372e95ec353c65853faa82.svg";
export { ForwardRef as ReactComponent };